import "./projects-box.scss";

import ProjectCard from "../project-card/Index";

import projects from "../../../database/projects.json";

const ProjectsBox = () => {
  return (
    <div className="projects-box">
      {projects.projects.map((data, ind) => (
        <div className="project-card" key={ind}>
          <ProjectCard data={data} />
        </div>
      ))}
    </div>
  );
};

export default ProjectsBox;
